import MeasurementMaximeterChart from "./MeasurementMaximeterChart";

export default MeasurementMaximeterChart;
